export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.multiple
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: !that.multiple
  },
  {
    title: that.$l('table_label_purchaseMaterialNo') || '采购单号',
    field: 'purchaseMaterialNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_materialNo') || '物料编码',
    field: 'materialNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_materialName') || '物料名称',
    field: 'materialName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_materialDesc') || '规格',
    field: 'materialDesc',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_cd#') || '规格',
    field: 'cd',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_qty') || '数量',
    field: 'qty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_unitPrice') || '含税单价',
    field: 'unitPrice',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => {
      return cellValue != null ? Number(cellValue).toFixed(2) : '--';
    },
  },
  {
    title: that.$l('table_label_subAmount') || '价税合计',
    field: 'subAmount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => {
      return cellValue != null ? Number(cellValue).toFixed(2) : '--';
    },
  },
  {
    title: that.$l('table_label_planArrivalDate') || '计划到货日期',
    field: 'planArrivalDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
  },

  {
    title: that.$l('table_label_purchaseStatus') || '状态',
    field: 'purchaseStatus',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    slots: {
      default: 'status',
    },
  },
  {
    title: that.$l('table_label_originOrderNo') || '源头订单号',
    field: 'originOrderNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_scmName') || '供方',
    field: 'scmName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_purchaserEntityName') || '需方',
    field: 'purchaserEntityName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_signPlace') || '签订地点',
    field: 'signPlace',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_buyerName') || '采购人员',
    field: 'buyerName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_totalAmount') || '采购金额',
    field: 'totalAmount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_reviewByName') || '审核人员',
    field: 'reviewByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_reviewTime') || '审核日期',
    field: 'reviewTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 140,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
    slots: {
      default: 'displayCreateByName',
    }
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
    slots: {
      default: 'displayModifyByName',
    }
  },
]
